import { Colors } from '@euler/components/Colors';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useBackButtonHandler } from '@euler/functions/useBackButtonHandler';
import {
  useScreenContentContainerStyle,
  wrapNavigatorScreen,
} from '@euler/functions/wrapNavigatorScreen';
import { FC, memo } from 'react';
import { ScrollView, Text, TextProps, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { BackButton } from '../components/BackButton';
import { CustomPageHeader } from '../components/CustomPageHeader';

const Tip: FC<TextProps> = memo(props => {
  const { rpx } = useResponsiveContext();
  return (
    <Text
      css={`
        font-family: ${FontFamily.NotoSans.Light};
        color: ${Colors.Gray2};
        font-size: ${rpx(15)}px;
        margin-bottom: ${rpx(16)}px;
      `}
      {...props}
    />
  );
});

export const VerifyCodeTipsScreen = wrapNavigatorScreen(
  () => {
    const contentContainerStyle = useScreenContentContainerStyle();
    const onGoBack = useBackButtonHandler();
    const insets = useSafeAreaInsets();
    const { rpx } = useResponsiveContext();

    return (
      <>
        <ScrollView
          contentContainerStyle={[
            {
              paddingTop: insets.top + rpx(96),
              paddingLeft: rpx(20),
              paddingRight: rpx(20),
              paddingBottom: rpx(20),
            },
            contentContainerStyle,
          ]}
        >
          <CustomPageHeader
            title="收不到短信验证码?"
            subTitle="可能是以下原因导致的"
          />

          <View
            css={`
              border-radius: ${rpx(20)}px;
              margin-bottom: ${rpx(32)}px;
              margin-top: ${rpx(44)}px;
            `}
          >
            <Tip>
              1、由于手机安全软件拦截，验证码短信被拦截进入了垃圾箱，请尝试打开垃圾箱查看
            </Tip>
            <Tip>
              2、由于运营商通道故障造成短信发送时间延时，请耐心等候或点击重新获取验证码
            </Tip>
            <Tip>
              3、请确保您的手机是否处于能正常接收短信状态，停机、欠费或短信箱存储已满均可能导致无法接收短信
            </Tip>
            <Tip>4、请检查手机号码是否输入正确</Tip>
          </View>
        </ScrollView>
        <BackButton
          onPress={onGoBack}
          color={'#333'}
          css={`
            position: absolute;
            left: ${rpx(20)}px;
            top: ${insets.top + rpx(15)}px;
          `}
        />
      </>
    );
  },
  {
    headerShown: false,
  },
);
